export const app = {
    CONFIRM_NUMBER_RESPONSE: 'app.CONFIRM_NUMBER_RESPONSE',
    CURRENT_DEVICE_ID: 'app.CURRENT_DEVICE_ID',
    INITIALIZED: 'app.INITIALIZED',
    DISPATCH_EMAIL: 'app.DISPATCH_EMAIL',
    DISPATCH_SUBSCRIPTION_DETAILS: 'app.DISPATCH_SUBSCRIPTION_DETAILS',
    PROFILE_PICTURE: 'app.PROFILE_PICTURE',
    USER_PREFERENCES: 'app.USER_PREFERENCES',
    RESET_APP_STATE: 'app.RESET_APP_STATE',
};
export const appTemp = {
    COUNTRY: 'appTemp.COUNTRY',
    RESET_APP_TEMP_STATE: 'appTemp.RESET_APP_TEMP_STATE',
    OPEN_FOLDER: 'appTemp.OPEN_FOLDER',
    CLOSE_FOLDER: 'appTemp.CLOSE_FOLDER',
    SET_FOLDER: 'appTemp.SET_FOLDER',
    SHOW_FILE_VIEW: 'appTemp.SHOW_FILE_VIEW',
    HIDE_FILE_VIEW: 'appTemp.HIDE_FILE_VIEW',
    CLOSE_ALBUM: 'appTemp.CLOSE_ALBUM',
    OPEN_ALBUM: 'appTemp.OPEN_ALBUM',
    FILE_TEMP_LOADED: 'appTemp.FILE_TEMP_LOADED',
    FILE_VIEW_SCROLL: 'appTemp.FILE_VIEW_SCROLL',
    RENAMING_FILE: 'appTemp.RENAMING_FILE',
    RESET_FOLDER_STACK: 'appTemp.RESET_FOLDER_STACK',
    IS_EMTPY_SEARCH: 'appTemp.IS_EMTPY_SEARCH',
    IS_SEARCHING: 'appTemp.IS_SEARCHING',
    CANCEL_MENUS: 'appTemp.CANCEL_MENUS',
    DISPATCH_APPTEMP_PROPERTY: 'appTemp.DISPATCH_APPTEMP_PROPERTY',
    MOVING_FILE: 'appTemp.MOVING_FILE',
    FETCH_DEVICES: 'appTemp.FETCH_DEVICES',
};
export const auth = {
    DISPATCH_USER: 'auth.DISPATCH_USER',
    FINISHED_REGISTRATION: 'auth.FINISHED_REGISTRATION',
    USER_LOADED: 'auth.USER_LOADED',
    LOGOUT_SUCCESSFUL: 'auth.LOGOUT_SUCCESSFUL',
    UPDATE_USER: 'auth.UPDATE_USER',
    UPDATE_STORAGE_USED: 'auth.UPDATE_STORAGE_USED',
};
export const cache = {
    CACHE_FILE_VAULT: 'cache.CACHE_FILE_VAULT',
};
export const download = {
    DOWNLOADING: 'download.DOWNLOADING',
    DOWNLOADED: 'download.DOWNLOADED',
    HEIC_PROCESSING: 'download.HEIC_PROCESSING',
    HEIC_PROCESSING_DONE: 'download.HEIC_PROCESSING_DONE',
};
export const progress = {
    START_LOADING: 'progress.START_LOADING',
    END_LOADING: 'progress.END_LOADING',
};
export const vault = {
    FETCH_FILES: 'vault.FETCH_FILES',
    FETCH_FILES_TREE: 'vault.FETCH_FILES_TREE',
    FETCH_PHOTOS: 'vault.FETCH_PHOTOS',
    FETCH_VAULT_NOTES: 'vault.FETCH_VAULT_NOTES',
    UPDATE_VAULT_NOTE: 'vault.UPDATE_VAULT_NOTE',
    FETCH_VAULT_ALBUMS: 'vault.FETCH_VAULT_ALBUMS',
    DELETE_FILE: 'vault.DELETE_FILE',
    DELETE_FILE_TREE: 'vault.DELETE_FILE_TREE',
    DELETE_PHOTO_FILE: 'vault.DELETE_PHOTO_FILE',
    DELETE_NOTE: 'vault.DELETE_NOTE',
    LOGOUT_FILES: 'vault.LOGOUT_FILES',
    LOGOUT_FILES_TREE: 'vault.LOGOUT_FILES_TREE',
    LOGOUT_PHOTOS: 'vault.LOGOUT_PHOTOS',
    LOGOUT_ALBUMS: 'vault.LOGOUT_ALBUMS',
    LOGOUT_NOTES: 'vault.LOGOUT_NOTES',
    MOVE_FILE: 'vault.MOVE_FILE',
    CREATE_NOTE: 'vault.CREATE_NOTE',
};
export const upload = {
    UPLOADING: 'upload.UPLOADING',
    UPLOADED: 'upload.UPLOADED',
    SHOW_MENU: 'upload.SHOW_MENU',
    HIDE_MENU: 'upload.HIDE_MENU',
    DISPATCH_FILES: 'upload.DISPATCH_FILES',
    CLEAR: 'upload.CLEAR',
    COUNT: 'upload.COUNT',
};
export const fetched = {
    RESET_FETCHED: 'fetched.RESET_FETCHED',
    FETCHED_FOLDER: 'fetched.FETCHED_FOLDER',
    FETCHED_VAULT_ALBUM: 'fetched.FETCHED_VAULT_ALBUM',
};
export const url = {
    NEXT_FILES_URL: 'url.NEXT_FILES_URL',
    NEXT_PHOTOS_URL: 'url.NEXT_PHOTOS_URL',
    NEXT_SEARCH_URL: 'url.NEXT_SEARCH_URL',
    NEXT_VAULT_NOTES_URL: 'url.NEXT_VAULT_NOTES_URL',
};
